export const DEFAULT_CURRENCY_SYMBOL = "€";

export const DEFAULT_CURRENCY_CODE = "EUR";

export const CURRENCY_MAP = {
  EUR: "€",
  USD: "$",
};
